import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Image, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 
'./hooks/useAuth';
import Swal from 'sweetalert2';

const AuthPage = () => {
    const navigate = useNavigate();

    const { error, authPost, auth } = useAuth();
    const [authData, setAuthData] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setAuthData((auth) => ({
            ...auth,
            [name]: value,
        }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = await authPost(authData)
        
        if (token?.status == 400 || token === undefined) {
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: 'Incorrect email or password. Please try again.',
            });
        } else {
            Swal.fire({
                icon: 'success',
                title: 'Login Successful!',
                text: 'Welcome back!',
                confirmButtonText: 'OK',
            }).then((result) => {
                localStorage.setItem("token", token?.token);
                if (result.isConfirmed) {
                    navigate('/'); // Navigate to dashboard or any page
                }
            });
        }
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: '90vh', backgroundColor: '#f0f0f0' }}>
            <Row className="w-100">
                {/* Left Column: Login Form */}
                <Col xs={12} md={6} className="d-flex justify-content-center align-items-center p-4">
                    <Card style={{ width: '100%', maxWidth: '400px' }}>
                        <Card.Body>
                            <div className="text-center">
                                {/* Logo (optional) */}
                                {/* <Image src="logo-yarsi.png" alt="Shopee Logo" fluid style={{ maxWidth: '150px', marginBottom: '20px' }} /> */}
                            </div>
                            <h3 className="text-center mb-4">Login</h3>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        onChange={handleChange}
                                        value={authData.username}
                                        placeholder="Enter your username" />
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword" className="mt-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        onChange={handleChange}
                                        value={authData.password}
                                        placeholder="Enter your password" />
                                </Form.Group>

                                <Button variant="primary" type="submit" className="w-100 mt-4">
                                    Login
                                </Button>
                            </Form>

                            <div className="text-center mt-3">
                                <span>
                                    Don't have an account? <a href="/signup">Sign Up</a>
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Right Column: Optional Image */}
                <Col xs={12} md={6} className="d-flex justify-content-center align-items-center p-0">
                    <Image
                        src="logo-yarsi.png" // Put the correct image path here
                        alt="Background Image"
                        fluid
                        style={{
                            maxHeight: '100%', // Ensure the image covers the full height of the column
                            objectFit: 'cover', // Maintain the aspect ratio while covering the container
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default AuthPage;
